module.exports = __webpack_public_path__ + "img/tree.c2e01ac6.svg";